import styled from '@emotion/styled';

export const StyledChatInputField = styled.div`
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    background: #fcfaff;
    height: fit-content;
    border-radius: 4px;
    padding: 12px 20px;
    margin: 12px 24px;
    min-height: 40px;
    display: flex;
    flex-grow: 1;
`;

export const StyledInputField = styled.input`
    background: inherit;
    margin-right: 8px;
    resize: none;
    width: 100%;

    &:hover,
    &:active,
    &:focus {
        outline: none;
    }
`;
